module.exports = {"330903001":"沈家门街道","330903003":"东港街道","330903004":"朱家尖街道","330903005":"展茅街道","330903100":"六横镇","330903102":"虾峙镇","330903104":"桃花镇","330903105":"东极镇","330903106":"普陀山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330903.json
// module id = 934
// module chunks = 0